import Vue from 'vue';
import Component from 'vue-class-component';
import { modalHelper, DataItem } from '@/components/modal/modalHelper';
import { Async } from '@/utils/AsyncDecorators';
import { Watch } from 'vue-property-decorator';
import Form from "./form.vue";
import { piantaSemeMarzeStore } from '../store/PiantaSemeMarze.store';
import { applyArrayChanges } from '@/utils/ApplyArrayChange';
import { versioneExSituStore } from '@/modules/VersioneExSitu/store/VersioneExSitu.store';
import { store } from '@/store';
import { areaSpecieProvenienzaStore } from '@/modules/AreaSpecieProvenienza/store/areaSpecieProvenienza.store';
import { layoutHelper } from '@/helpers/LayoutHelper';
import { localVersionHelper } from '@/helpers/LocalVersionHelper';
import Display from './display.vue';

Vue.component("pianta-seme-marze-item", () => !layoutHelper.isWeb ? import("./mobile/PiantaSemeMarzeMobileItem.vue") : import("./web/PiantaSemeMarzeWebItem.vue"));

@Component({})
export default class Index extends Vue {
  showSearchBar: boolean = false;

  @Async({ async get() { return await piantaSemeMarzeStore.getters.getAll() }, default: [], lazy: true })
  PianteSemeMarze: server.PiantaSemeMarze[];

  @Async({ async get() { return await areaSpecieProvenienzaStore.getters.getAll() }, default: [], lazy: false })
  storeSpecieProvenienza: server.areaSpecieProvenienza[];

  @Async({ async get() { return await versioneExSituStore.getters.current() }, default: {}, lazy: false })
  currentVersion: server.VersioneExSitu;

  get areeSpecieProvenienza() {
    return this.storeSpecieProvenienza.map((m) => {
      return {
        key: m.id,
        value: m.id,
        description: m.nome,
      } as server.autocomplete
    })
  }

  get navigation() {
    const areaSpecieProvenienzaId = store.getters.navigation.selected("areaSpecieProvenienza");
    if(areaSpecieProvenienzaId) {
      return this.areeSpecieProvenienza.find(f => f.key === areaSpecieProvenienzaId) || {} as server.autocomplete;
    }
    return null;
  }
  
  set navigation(value: server.autocomplete) {
    store.actions.navigation.set_filter({ area: "areaSpecieProvenienza", id: value ? value.key: null });
  }

  filter = {
    text: "",
  };

  selectedArea: server.PiantaSemeMarze = null;

  applyFilter(items: server.PiantaSemeMarze[]): server.PiantaSemeMarze[] {
    return items.filter(i => (!this.navigation || i.areaSpecieProvenienzaId === this.navigation.key)
      );
    };

  @Watch('filter.text') change(n, o) { this.showsize = 20; }
  showsize: number = 20;

  get areeOrdered(): server.PiantaSemeMarze[] {
    return this.applyFilter(this.PianteSemeMarze)
      // .sort((a, b) => b.dataRilievo.getTime() - a.dataRilievo.getTime())
      .slice(0, this.showsize);
  }

  async edit(item: server.PiantaSemeMarze) {
    this.selectedArea = item;
    try {
      var result: DataItem<server.PiantaSemeMarze>;
      if (localVersionHelper.get("ExSitu")) {
        result = await modalHelper.showModal<server.PiantaSemeMarze>(Display, Object.assign({}, item));
      } else {
        result = await modalHelper.showModal<server.PiantaSemeMarze>(Form, Object.assign({}, item));
      }
      applyArrayChanges([result], this.PianteSemeMarze, (a, b) => a.id == b.id);
    } catch { }
    this.selectedArea = null;
  }

  async add() {
    try {
      let item: server.PiantaSemeMarze = { versioneId: this.currentVersion.id, data: new Date(), geoJSON:null, codice: this.randomString(16, '#A') } as server.PiantaSemeMarze;
      item.areaSpecieProvenienzaId = store.getters.navigation.selected("areaSpecieProvenienza");
      let result = await modalHelper.showModal<server.PiantaSemeMarze>(Form, Object.assign({}, item));
      applyArrayChanges([result], this.PianteSemeMarze, (a, b) => a.id == b.id);
    } catch { }
  }

  randomString(length, chars) {
    var mask = '';
    if (chars.indexOf('a') > -1) mask += 'abcdefghilmnopqrstuvz';
    if (chars.indexOf('A') > -1) mask += 'ABCDEFGHILMNOPQRSTUVZ';
    if (chars.indexOf('#') > -1) mask += '0123456789';
    if (chars.indexOf('!') > -1) mask += '~`!@#$%^&*()_+-={}[]:";\'<>?,./|\\';
    var result = '';
    for (var i = length; i > 0; --i) {
      result += mask.charAt(Math.floor(Math.random() * mask.length));
    }
    return result;
  }

  onShow(){
    return localVersionHelper.get("ExSitu") ? true : false
  }
  
}